import { HttpErrorResponse } from '@angular/common/http';
import { EmptyObject } from 'src/app/shared/services/generic-bloc.service';

export enum RecoveryBlocEvent {
  changePassword,
}

export type RecoveryBlocEventPayloads = {
  [RecoveryBlocEvent.changePassword]: { confirmPassword: string; password: string; id: string };
};

export enum RecoveryBlocAction {
  passwordChanged,
  passwordChangedFailed,
}

export type RecoveryBlocActionPayloads = {
  [RecoveryBlocAction.passwordChanged]: EmptyObject;
  [RecoveryBlocAction.passwordChangedFailed]: { error: HttpErrorResponse };
};
